import { useEffect } from 'react';
import HeroSection from '../components/features/HeroSection';
import { usePageMeta } from '../lib/usePageMeta';
import FeaturedProducts from '../components/features/FeaturedProducts';
import ServicesPreview from '../components/features/ServicesPreview';
import BrandStrip from '../components/features/BrandStrip';
import PaymentMethodsStrip from '../components/features/PaymentMethodsStrip';
import Footer from '../components/layout/Footer';
import { useI18n } from '../hooks/useI18n';

export default function HomePage() {
  const { t } = useI18n();
  usePageMeta('TECNICELU S.A. — Tecnología del futuro', 'Tu tecnología, nuestra pasión. Envíos a todo Colombia.');
  useEffect(() => {
    document.documentElement.classList.add('home-snap-active');
    return () => document.documentElement.classList.remove('home-snap-active');
  }, []);

  return (
    <main className="home-snap-page page-transition">
      <HeroSection />
      <div className="home-snap-divider mx-auto h-px max-w-5xl bg-gradient-to-r from-transparent via-line to-transparent" />
      <FeaturedProducts />
      <div className="home-snap-divider mx-auto h-px max-w-5xl bg-gradient-to-r from-transparent via-line to-transparent" />
      <ServicesPreview />
      <div className="home-snap-section">
        <div className="flex min-h-[calc(100dvh-var(--snap-top,4rem)-11rem)] w-full flex-col justify-center md:min-h-0">
          <BrandStrip />
          <section className="mt-8 border-b border-line/60 bg-surface/45 py-6 sm:py-8" aria-label={t('home_payment_methods')}>
            <div className="container mx-auto px-3 sm:px-4">
              <div className="mb-4 flex items-center justify-center gap-2 sm:gap-3">
                <span aria-hidden="true" className="h-px w-6 bg-brand/45 sm:w-10 md:w-14" />
                <h2 className="rounded-full border border-brand/25 bg-brand/10 px-3 py-1.5 font-display text-xs font-bold uppercase tracking-[0.12em] text-ink shadow-sm shadow-brand/10 sm:px-4 sm:py-2 sm:text-sm">
                  {t('home_payment_methods')}
                </h2>
                <span aria-hidden="true" className="h-px w-6 bg-accent/45 sm:w-10 md:w-14" />
              </div>
              <div className="flex justify-center overflow-hidden"><PaymentMethodsStrip /></div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    </main>
  );
}
